import { render, staticRenderFns } from "./SalesStatement.vue?vue&type=template&id=7708abd9&"
import script from "./SalesStatement.vue?vue&type=script&lang=js&"
export * from "./SalesStatement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports